<span
  class="inline-block border-1"
  [ngClass]="{
    'border-yellow-100 bg-yellow-50 text-grey': type === 'info',
    'border-blue-100 bg-blue-50 text-grey': type === 'notice',
    'border-orange-100 bg-orange-50 text-grey': type === 'warning',
    'border-green-100 bg-green-50 text-grey': type === 'success',
    'border-red-100 bg-red-50 text-grey': type === 'error',

    'rounded-[3px] px-2 py-1 text-xs': size === 'small',
    'rounded-md px-4 py-1.5 text-sm': size === 'default',
    'rounded-lg text-xl': size === 'large',
  }"
>
  <ng-content />
</span>
